// Projects
const Projects = {
  loading: false,
  projects: [],
  error: null,
};

export const reducerGetProjects = (state = Projects, action) => {
  switch (action.type) {
    case "GET_PROJECTS_START":
      return { ...state, loading: true, error: null };
    case "GET_PROJECTS_SUCCESS":
      return { ...state, loading: false, projects: action.payload };
    case "GET_PROJECTS_ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Categories
const Categories = {
  loading: false,
  categories: [],
  error: null,
};

export const reducerGetCategories = (state = Categories, action) => {
  switch (action.type) {
    case "GET_CATEGORIES_START":
      return { ...state, loading: true, error: null };
    case "GET_CATEGORIES_SUCCESS":
      return { ...state, loading: false, categories: action.payload };
    case "GET_CATEGORIES_ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// News
const News = {
  loading: false,
  news: [],
  error: null,
};

export const reducerGetNews = (state = News, action) => {
  switch (action.type) {
    case "GET_NEWS_START":
      return { ...state, loading: true, error: null };
    case "GET_NEWS_SUCCESS":
      return { ...state, loading: false, news: action.payload };
    case "GET_NEWS_ERROR":
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
